document.addEventListener('DOMContentLoaded', function () {
       /**
        * Throttle function to delay the execution of a callback
        */
 function throttle(func, delay) {
    let timer = null;
       return function () {
         const context = this;
         const args = arguments;
         clearTimeout(timer);
         timer = setTimeout(function () {
          func.apply(context, args);
         }, delay || 300);
       };
     }

       /**
        * Reset the search list display
        */
     function resetSearchList() {
       document.querySelectorAll('.search__list .all__results, .search__list .results__wrapper').forEach(el => {
         el.style.display = 'none';
       });
       document.querySelectorAll('.search__list .results').forEach(el => {
         el.innerHTML = '';
       });
       document.querySelector('.search__list').style.overflow = 'hidden';
     }

       /**
        * Helper to fade in an element
        */
     function fadeIn(el) {
       el.style.opacity = 0;
       el.style.display = 'block';
       let last = +new Date();
       const tick = function () {
         el.style.opacity = +el.style.opacity + (new Date() - last) / 200;
         last = +new Date();

         if (+el.style.opacity < 1) {
           requestAnimationFrame(tick);
         }
       };
       tick();
     }

         // -- open search form --
     document.querySelector('.searchTrigger').addEventListener('click', function () {
       document.body.classList.add('search--open');
       document.querySelector('.search__input').focus();
     });

          //-- close search form --
     document.querySelector('.btn__close').addEventListener('click', function () {
       document.body.classList.remove('search--open');
       document.querySelector('.search__input').blur();
     });

        //  -- search autocomplete logic --
     let lastValue = '';

     document.querySelector('.search__input').addEventListener('keyup', throttle(function (e) {
       const input = e.target;
       const val = input.value;
       const jsonUrl = document.querySelector('.search__form').getAttribute('data-jsonurl');

       if (val.length === 0) {
         resetSearchList();
         return;
       }

       if (val.length <= 1 || val === lastValue) {
         return;
       }

       resetSearchList();

           //   Helper to fetch JSON and return data
       function fetchJSON(url, callback) {
         fetch(url)
         .then(response => response.json())
         .then(json => callback(json.data));
       }

       
         const jsonUrlAll = jsonUrl + '?q=' + encodeURIComponent(val);
         fetchJSON(jsonUrlAll, function (data) {
            const sections = {
                artists: [],
                events: [],
                exhibitions: [],
                artworks: [],
                publications: [],
                news: [],
                mainMenu: []
              };

            const sectionMap = {
                typeArtists: 'artists',
                typeEvents: 'events',
                typeExhibitions: 'exhibitions',
                typeSmallMuseum: 'exhibitions',
                typeVirtualResidency: 'exhibitions',
                typeArtworks: 'artworks',
                typePublications: 'publications',
                typeNews: 'news',
                typeWebpage: 'mainMenu',
                typeCollection: 'mainMenu',
                typeChannelList: 'mainMenu',
              };

              data.forEach(item => {
                const html = `<li><a href="${item.url}">${item.title}</a></li>`;
                const key = sectionMap[item.sectionType];
                if (key && sections[key]) {
                  sections[key].push(html);
                }
              });

           document.querySelector('.search__list').style.overflow = 'scroll';

           if (Object.values(sections).some(arr => arr.length > 0)) {
             fadeIn(document.querySelector('.search__list .all__results'));
           }

           if (sections.artists.length) {
             document.querySelector('.results--artists').innerHTML = sections.artists.join('');
             fadeIn(document.querySelector('.artists__wrapper'));
           }
           if (sections.events.length) {
             document.querySelector('.results--events').innerHTML = sections.events.join('');
             fadeIn(document.querySelector('.events__wrapper'));
           }
           if (sections.exhibitions.length) {
             document.querySelector('.results--exhibitions').innerHTML = sections.exhibitions.join('');
             fadeIn(document.querySelector('.exhibitions__wrapper'));
           }
           if (sections.artworks.length) {
             document.querySelector('.results--artworks').innerHTML = sections.artworks.join('');
             fadeIn(document.querySelector('.artworks__wrapper'));
           }
            if (sections.publications.length) {
                document.querySelector('.results--publications').innerHTML = sections.publications.join('');
                 fadeIn(document.querySelector('.publications__wrapper'));
              }
              if (sections.news.length) {
                document.querySelector('.results--news').innerHTML = sections.news.join('');
                 fadeIn(document.querySelector('.news__wrapper'));
              }
              if (sections.mainMenu.length) {
                document.querySelector('.results--others').innerHTML = sections.mainMenu.join('');
                fadeIn(document.querySelector('.others__wrapper'));
              }
         });

         /* const jsonUrlCategories = jsonUrl + '/categories?q=' + encodeURIComponent(val);

         fetchJSON(jsonUrlCategories, function (data) {
           const categories = {
             thematics: [],
             tags: []
           };

           data.forEach(item => {
             const html = `<li><a href="${item.url}">${item.title}</a></li>`;
             if (categories[item.group]) {
               categories[item.group].push(html);
             }
           });

           if (categories.thematics.length || categories.tags.length) {
             fadeIn(document.querySelector('.search__list .all__results'));
           }

           if (categories.thematics.length) {
             document.querySelector('.results--thematics').innerHTML = categories.thematics.join('');
             fadeIn(document.querySelector('.thematics__wrapper'));
           }
           if (categories.tags.length) {
             document.querySelector('.results--tags').innerHTML = categories.tags.join('');
             fadeIn(document.querySelector('.thematics__wrapper'));
           }
         }); */

       
     

       lastValue = val;

     }, 400));

   });